export default (function (arr) { return arr.slice(0, -1); });



//////////////////
// WEBPACK FOOTER
// ./~/@reecelucas/react-use-hotkeys/esm/helpers/takeUntilLast.js
// module id = 661
// module chunks = 0